export default function Footer() {
  return (
    <footer className="relative bg-zinc-950 border-t border-zinc-800 py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-xl font-black text-white mb-4">AMPERO II CAPTURES</h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              Captures profissionais de high gain criadas por Tom Chagas para guitarristas de metal e hardcore.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">Links Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <a href="#oferta-especial" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 cursor-pointer">
                  Comprar Agora
                </a>
              </li>
              <li>
                <a href="mailto:contato@tomcore.com" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 cursor-pointer">
                  Contato
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 cursor-pointer">
                  Suporte
                </a>
              </li>
            </ul>
          </div>

          {/* Compatibility */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">Compatibilidade</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-orange-500"></i>
                Hotone Ampero II Stage
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-orange-500"></i>
                Hotone Ampero II MP350
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-orange-500"></i>
                Hotone Ampero Stomp II
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-zinc-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">
            © 2025 AMPERO II CAPTURES - TOMCORE. Todos os direitos reservados.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-500 hover:text-orange-500 transition-colors duration-300 cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
